module.exports = __webpack_public_path__ + "static/img/5g.071247c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/5g.png
// module id = POX/
// module chunks = 1